import axios from 'axios';

class Service {

    //baseUrl = 'http://localhost:9080';
    //baseUrl = 'http://localhost:8099';
    baseUrl = 'https://condemakoto.com';

    sendContactMessage(contactInfo) {
        return axios.post(this.baseUrl + '/portfolio_api/contact', contactInfo);
    }

    loadGallery(galleryId) {
        const params = galleryId ? `?gallery=${galleryId}` : "";
        return axios.get(this.baseUrl + "/portfolio_api/gallery" + params);
    }

    getServiceStatus() {
        return axios.get('http://condemakoto.com/analytics/serviceStatus');
    }

    login(loginInfo) {
        return axios.post(this.baseUrl + '/auth/login', loginInfo);
    }

    register(registerInfo) {
        return axios.post(this.baseUrl + '/auth/register', registerInfo);
    }

    requestPasswordReset(user) {
        return axios.post(this.baseUrl + `/auth/requestPasswordReset?user=${user}`, {});
    }

    resetPassword(request) {
        return axios.post(this.baseUrl + '/auth/resetPassword', request);
    }

    storeUserInfo(userInfo) {
        localStorage.setItem('userInfo', JSON.stringify(userInfo));
    }

    getUserInfo() {
        const serializedUserInfo = localStorage.getItem('userInfo');
        if (serializedUserInfo) {
            return JSON.parse(serializedUserInfo);
        }
        return null;
    }

    storeTokenInfo(tokenInfo) {
        localStorage.setItem('token', JSON.stringify(tokenInfo));
    }

    getHeaders() {
        return {
            headers: {
                'token': this.getToken(),
                'Content-Type': 'application/json'
            }
        };
    }

    getToken() {
        const tokenInfo = localStorage.getItem('token');
        if (tokenInfo !== undefined && tokenInfo !== null) {
            try {
                const tokenStruct = JSON.parse(tokenInfo);
                return tokenStruct.token;
            } catch (err) {
                console.log(err);
                localStorage.removeItem('token');
            }
        }
        return '';
    }

    logout() {
        localStorage.setItem('token', null);
        localStorage.setItem('userInfo', null);
    }

    updatePassword(newPassword) {
        const request = {password: newPassword};
        console.log(request);
        console.log(JSON.stringify(request));
        return axios.post(this.baseUrl + '/auth/updatePassword',
            JSON.parse(JSON.stringify(request)),
            this.getHeaders());
    }
}

export default Service;


// WEBPACK FOOTER //
// ./src/service/service.js